import { useBottom } from '@lib/hooks'
import React from 'react'
import { RefreshControl, ScrollView } from 'react-native'
import { KeyboardAwareScrollView, KeyboardAwareScrollViewProps } from 'react-native-keyboard-controller'
import { useTheme } from 'styled-components/native'

const paddingTop = 10
const paddingBottom = 30

type KeyboardViewProps = KeyboardAwareScrollViewProps & {
  isRefreshing?: boolean
  onRefresh?: () => void
  ref?: React.Ref<ScrollView>
}

export function KeyboardView({ onRefresh, isRefreshing, children, ref, ...props }: KeyboardViewProps) {
  const theme = useTheme()
  const bottomOffset = useBottom(0, paddingBottom)

  return (
    <KeyboardAwareScrollView
      ref={ref}
      contentContainerStyle={{
        paddingBottom: bottomOffset,
        paddingTop,
      }}
      keyboardShouldPersistTaps="handled"
      bottomOffset={20}
      {...props}
      refreshControl={
        onRefresh && (
          <RefreshControl
            colors={[theme.colors.primary]}
            tintColor={theme.colors.primary}
            refreshing={!!isRefreshing}
            onRefresh={onRefresh}
          />
        )
      }
    >
      {children}
    </KeyboardAwareScrollView>
  )
}
